import { useState } from 'react';
import { INotificationManager } from 'src/contexts/NotificationContextBase/types';

const useNotifications = (): INotificationManager => {
  const [errors, setErrors] = useState<string[]>([]);
  const [notice, setNotice] = useState<string>();

  const clearAllNotifications = () => {
    setErrors([]);
    setNotice(undefined);
  };

  return {
    errors,
    notice,
    setErrors,
    setNotice,
    clearAllNotifications,
  };
};

export default useNotifications;
